import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';
import { Paginated } from '@app/shared/models';
import { Student, StudentDto } from '../models';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private httpClient = inject(HttpClient);

    getStudents(page: number, limit: number): Observable<Paginated<Student[]>> {
        const params = new HttpParams().set('page', page.toString()).set('limit', limit.toString());

        return this.httpClient.get<StudentDto[]>('manage/users', { params, observe: 'response' }).pipe(
            mapDto((response) => ({
                total: parseInt(response.headers.get('X-Total-Count') ?? '0'),
                items: response.body?.map((dto) => new Student(dto)) ?? [],
            })),
        );
    }
}
